import { render, staticRenderFns } from "./OasisVista.vue?vue&type=template&id=d35d04f8&scoped=true&"
import script from "./OasisVista.vue?vue&type=script&lang=js&"
export * from "./OasisVista.vue?vue&type=script&lang=js&"
import style0 from "./OasisVista.vue?vue&type=style&index=0&id=d35d04f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35d04f8",
  null
  
)

export default component.exports